import { getPerfFlagOverridesSnapshot, normalizeEndpoint } from './perf-telemetry';

interface BuildApiCallEventInput {
  config?: {
    url?: string;
    method?: string;
    data?: unknown;
  };
  response?: {
    status?: number;
    headers?: Record<string, unknown>;
    data?: unknown;
  };
  error?: {
    code?: string;
  };
  elapsedMs: number;
}

const headerValue = (headers: Record<string, unknown> | undefined, name: string): string | undefined => {
  if (!headers) return undefined;
  const match = Object.keys(headers).find((key) => key.toLowerCase() === name.toLowerCase());
  const value = match ? headers[match] : undefined;
  return value == null ? undefined : String(value);
};

const approximateBytes = (value: unknown): number | undefined => {
  if (value === undefined || value === null) return undefined;
  if (typeof value === 'string') return value.length;
  try {
    return JSON.stringify(value).length;
  } catch {
    return undefined;
  }
};

export const buildApiCallEvent = ({
  config,
  response,
  error,
  elapsedMs,
}: BuildApiCallEventInput) => {
  const featureFlags = getPerfFlagOverridesSnapshot();
  const featureFlagKeys = Object.keys(featureFlags);

  return {
    endpoint: normalizeEndpoint(config?.url),
    method: String(config?.method || 'get').toUpperCase(),
    ms: elapsedMs,
    status: response?.status,
    request_id: headerValue(response?.headers, 'x-quipa-request-id'),
    request_bytes: approximateBytes(config?.data),
    response_bytes: approximateBytes(response?.data),
    errorCode: error?.code,
    timeout: error?.code === 'ECONNABORTED' || undefined,
    feature_flags: featureFlagKeys.length ? featureFlags : undefined,
  };
};
